import React, { useCallback, useEffect } from 'react';
import { Outlet, useNavigate } from "react-router";
import { useDispatch } from 'react-redux';
import { NotAuthFormLayout, NotAuthLayout } from 'components';
import { loginStepOne } from 'redux_toolkit/reducers/app/appSlice';

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const LayoutPartners = ()=> {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initAppCallback = useCallback(() => {
    dispatch(loginStepOne());
  }, [ dispatch ]);

  useEffect(()=> {
    initAppCallback();
  }, [initAppCallback])

  useEffect(()=> {
    if(localStorage.getItem('superadmin_token')) {
      navigate("/superadmin/home");
      return;
    }

    const token = localStorage.getItem('access_token');
    if(!token || isTokenExpired(token)) {
      localStorage.removeItem('access_token');
      navigate('/login');
      return;
    }

    const payload = JSON.parse(atob(token.split('.')[1]));
    const msUntilExpiry = payload.exp * 1000 - Date.now();

    const timeout = setTimeout(() => {
      localStorage.removeItem('access_token');
      navigate('/login');
    }, msUntilExpiry);

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <>
      {<NotAuthLayout>
        <NotAuthFormLayout headerHeight={125}>
          <Outlet />
        </NotAuthFormLayout>
      </NotAuthLayout>}
    </>
  )
}